export default __webpack_public_path__ + "static/media/temp stay E2 - Temporary stay visa for transfer of workers.ee4783dc.jpg";